import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'Money',
  field: 'Measurement',
  weeks: [1, 2],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      smallStep: 'CountMoneyPence',
      questionTypes: ['bh9', 'bia', 'bib'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/Money/1CountMoneyPence" */ './1CountMoneyPenceModels'
        )
    }),
    // Step 2
    newSmallStepContent({
      smallStep: 'CountMoneyPoundsNotesAndCoins',
      questionTypes: ['bic', 'bid', 'bie'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/Money/2CountMoneyPoundsNotesAndCoins" */ './2CountMoneyPoundsNotesAndCoinsModels'
        )
    }),
    // Step 3
    newSmallStepContent({
      smallStep: 'CountMoneyPoundsAndPence',
      questionTypes: ['bif', 'big', 'bih'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/Money/3CountMoneyPoundsAndPence" */ './3CountMoneyPoundsAndPenceModels'
        )
    }),
    // Step 4
    newSmallStepContent({
      smallStep: 'ChooseNotesAndCoins',
      questionTypes: ['bii', 'bij', 'bik'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/Money/4ChooseNotesAndCoins" */ './4ChooseNotesAndCoinsModels'
        )
    }),
    // Step 5
    newSmallStepContent({
      smallStep: 'MakeTheSameAmount',
      questionTypes: ['bil', 'bim', 'bin'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/Money/5MakeTheSameAmount" */ './5MakeTheSameAmountModels'
        )
    }),
    // Step 6
    newSmallStepContent({
      smallStep: 'CompareAmountsOfMoney',
      questionTypes: ['bio', 'bip2', 'biq'],
      archivedQuestionTypes: ['bip'],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/Money/6CompareAmountsOfMoney" */ './6CompareAmountsOfMoneyModels'
        )
    }),
    // Step 7
    newSmallStepContent({
      smallStep: 'CalculateWithMoney',
      questionTypes: ['bir', 'bis', 'bit'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/Money/7CalculateWithMoney" */ './7CalculateWithMoneyModels'
        )
    }),
    // Step 8
    newSmallStepContent({
      smallStep: 'MakeAPound',
      questionTypes: ['biu', 'biv', 'biw'],
      archivedQuestionTypes: [],
      module: () =>
        import(/* webpackChunkName: "Year2/Spring/Money/8MakeAPound" */ './8MakeAPoundModels')
    }),
    // Step 9
    newSmallStepContent({
      smallStep: 'FindChange',
      questionTypes: ['bix', 'biy2', 'biz'],
      archivedQuestionTypes: ['biy'],
      module: () =>
        import(/* webpackChunkName: "Year2/Spring/Money/9FindChange" */ './9FindChangeModels')
    }),
    // Step 10
    newSmallStepContent({
      smallStep: 'TwoStepProblems',
      questionTypes: ['biA', 'biB', 'biC'],
      archivedQuestionTypes: [],
      module: () =>
        import(
          /* webpackChunkName: "Year2/Spring/Money/10TwoStepProblems" */ './10TwoStepProblemsModels'
        )
    })
  ]
});
export default Block;
